import { Box, Icon, IconSize } from '@bechtel/gds';
import { ExternalLinkStyled } from './styled';

interface ExternalLinkProps {
  onClick: () => void;
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({ onClick }) => {
  return (
    <Box alignItems={{ sm: 'center' }}>
      <ExternalLinkStyled onClick={onClick}>
        <Icon icon="external-link" iconStyle="regular" fillColor="blue.600" size={IconSize.XSMALL} />
      </ExternalLinkStyled>
    </Box>
  );
};
